// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.105.1/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.omegaup-feedback-row {\n  margin: 30px auto 0;\n}\n.omegaup-feedback-title {\n  font-weight: bold;\n  color: gray;\n}\n", ""]);
// Exports
module.exports = exports;
